import api from '~/modules/services/api-service';

/** Platform route the docs site bounces an unauthenticated visitor to for the SSO handshake. */
export const DOCS_AUTH_PATH = '/docs/auth';

/**
 * Complete the documentation single-sign-on handshake.
 *
 * Asks the API to mint a short-lived docs JWT for the current (authenticated) user, then hands
 * the browser to the Papervine callback — `https://<docs-host>/login/jwt-callback?redirect=…#<jwt>`
 * — which verifies the token and lands the visitor on the page they originally wanted. The docs
 * destination rides in the current URL's `redirect` param (set by the docs site), so it's read
 * straight from there rather than passed in.
 *
 * Shared by the two paths that reach an authenticated session on `/docs/auth`: the page itself
 * (visitor already signed in) and the post-login redirect (visitor signed in via the modal).
 *
 * @returns {Promise<void>}
 */
export const completeDocsHandshake = () => {
	const redirect = new URLSearchParams(window.location.search).get('redirect') || '/';
	return api.client.get('/session/docs', { params: { redirect } })
		// On success the API always returns a callback URL; the `|| '/'` keeps us off an endless
		// spinner if it ever doesn't, mirroring the error fallback below.
		.then(({ data } = {}) => window.location.replace(data?.url || '/'))
		.catch(() => window.location.replace('/'));
};
